import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id D71DFC98-3401-4268-9956-3EFEEE336235
 * name music-note-quarter
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/music-note-quarter.svg
 * tags
 * - Audio 
 * - Music 
 */
export const MusicNoteQuarterIcon = createSvgIcon(<><path d="M14 3V13.56C13.41 13.21 12.73 13 12 13C9.79 13 8 14.79 8 17S9.79 21 12 21 16 19.21 16 17V3H14Z" /></>, 'MusicNoteQuarterIcon');
export default MusicNoteQuarterIcon